import { render, staticRenderFns } from "./PatientDisplay.vue?vue&type=template&id=9b90000e&scoped=true&"
import script from "./PatientDisplay.vue?vue&type=script&lang=js&"
export * from "./PatientDisplay.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./PatientDisplay.vue?vue&type=style&index=1&id=9b90000e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b90000e",
  null
  
)

export default component.exports